var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"world-container"}},[_c('div',{ref:"worldRef",attrs:{"id":"world"}},[_c('Map',{attrs:{"data":_vm.data}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }